<div class="p-grid workStyle">
  <div class="p-col-8">
    <div class="p-grid">
      <div class="p-col-5 header">
        Tree {{type}} [<a [routerLink]="getNavigationURL()" tabindex="0" target="blank">{{workOrder.quoteNumber}}</a>]
      </div>
      <div class="p-col-3" style="text-align: right; font-weight: bold;">
        {{workOrder.priceSummary | currency}}
      </div>
      <div class="p-col-3" style="font-weight:bold">
        Work Status
      </div>
      <div class="p-col-1" style="font-weight:bold">
        Pay Status
      </div>
    </div>
    @for (task of tasks; track task) {
      <div class="p-grid">
        <div class="p-col-5">
          <p-checkbox [(ngModel)]="task.selected" binary="true" [disabled]="task.disabled" (ngModelChange)="confirmInvoiceRowChecked($event, task)"></p-checkbox>
          {{task.name}}: {{getTreeList(task)}}, {{task.location}}
        </div>
        <div class="p-col-3" style="text-align: right;">
          {{task.price | currency}}
        </div>
        <div class="p-col-3">
          {{showStatusAndApplicableDateIfAny(task)}}
        </div>
        <div class="p-col-1">
          {{task.paymentStatus ? task.paymentStatus : 'Not Paid'}}
        </div>
      </div>
    }
  @if (cashToInvoice > 0) {
    <div class="p-grid">
      <div class="p-col-12">
        <label for="total" style="font-weight:bold"><span class="totalLabel">Cash Or Check Collected And Not Invoiced</span>&nbsp;&nbsp;</label>
        <div>
          <input
            pInputText
            name="cashCollected"
            [textMask]="{mask: currencyMask}"
            [ngModel]="cashToInvoice"
            [disabled]="true"
            class="totalBoxes"
            required/>
        </div>
      </div>
    </div>
  }
</div>
<div class="p-col-4" style="text-align: right;">
  <div style="margin-bottom:4px;">
    <label><span class="totalLabel">Autocharge: <b>{{workOrder.autoChargeEnabled ? 'Enabled' : 'Disabled'}}</b></span></label>
  </div>
  <div>
    <p-button type="button" label="Generate Invoice" (click)="confirmGenerateInvoice()"  [disabled]="generating || !canInvoice"></p-button>
  </div>
</div>
</div>